
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/second-litter",
      function () {
        return require("private-next-pages/second-litter/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/second-litter"])
      });
    }
  